let theProduct;

let isProcessingWarranty = false;
let isModalOpen = false;
let isAddingWarrantyInternally = false; // Flag to skip event processing when we're adding warranty
let eventProcessTimeout = null; // Debounce event processing
let isCartEventBound = false;
let lastProcessedCartItemKey = null;
let lastProcessedAt = 0;

const hideMulberry = [
  "/products/6100-max-tnsr",
  "/products/8200-max-tnsr",
  "/products/netgate-8300-base-tnsr-secure-router",
  "/products/netgate-8300-max-tnsr-secure-router",
  "/products/netgate-8300-taa-tnsr-secure-router",
];
const CART_EVENT_DELAY = 0;
const MODAL_OPEN_DELAY = 0;
const CART_EVENT_COOLDOWN = 0;

console.log('Mulberry script initialized');

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function closeCartDrawerIfOpen() {
  const cartDrawer = document.querySelector('#CartDrawer');
  const isDrawerOpen = cartDrawer?.classList.contains('drawer--is-open');

  if (!isDrawerOpen) return;

  document.dispatchEvent(new CustomEvent('cart:close'));

  const closeButton = cartDrawer.querySelector('.js-drawer-close');
  if (cartDrawer.classList.contains('drawer--is-open') && closeButton) {
    closeButton.click();
  }

  await wait(550);
}

// ==========================
// VARIANT HELPER
// ==========================
function getCurrentlySelectedVariant(product) {
  let selectedVariant = product.variants.find(
    (i) => i.id == mulberryShop.selectedVariantId
  );
  if (!selectedVariant) {
    selectedVariant = product.variants[0];
  }

  mulberryShop.selectedVariantId = selectedVariant.id;

  return selectedVariant;
}

// ==========================
// MAIN VARIANT HELPER
// ==========================
function getMainVariant(product) {
 
  const mainVariant = product.variants[0];
  

  mulberryShop.selectedVariantId = mainVariant.id;

  return mainVariant;
}

// ==========================
// PRODUCT ADDED TO CART EVENT LISTENER
// ==========================
function isWarrantyProduct(item) {
  // Check if product is a warranty/guarantee product from Mulberry
  if (!item) return false;
  
  // Check title
  if (item.title?.includes('Guarantee') ||
      item.title?.includes('Protection') ||
      item.title?.includes('Warranty')) {
    return true;
  }
  
  // Check if it has warranty/mulberry properties
  if (item.properties) {
    const propsStr = JSON.stringify(item.properties).toLowerCase();
    if (propsStr.includes('warranty') || propsStr.includes('mulberry') || propsStr.includes('guarantee')) {
      return true;
    }
  }
  
  // Check vendor
  if (item.vendor?.toLowerCase().includes('mulberry') ||
      item.vendor?.toLowerCase().includes('warranty') ||
      item.vendor?.toLowerCase().includes('guarantee')) {
    return true;
  }
  
  return false;
}

async function handleProductAddedToCart(event) {
  console.log('Product added to cart event detected:', event);
  // Skip if we're internally adding a warranty
  if (isAddingWarrantyInternally) {
    console.log('[SKIPPED] Event ignored - internally adding warranty');
    return;
  }
  
  // Debounce: prevent rapid successive calls
  clearTimeout(eventProcessTimeout);
  
  eventProcessTimeout = setTimeout(async () => {
    try {
      if (isAddingWarrantyInternally) {
        console.log('[SKIPPED] Timeout ignored - internally adding warranty');
        return;
      }

      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      if (!cart.items || cart.items.length === 0) return;

      const lastCartItem = [...cart.items].reverse()[0];

      if (isWarrantyProduct(lastCartItem)) {
        console.log('Latest cart item is a warranty product, skipping modal flow');
        return;
      }
      
      // Get all non-warranty items to find the last user-added product
      const lastNonWarrantyItem = [...cart.items].reverse().find(item => !isWarrantyProduct(item));
      
      if (!lastNonWarrantyItem) {
        console.log('No non-warranty items found in cart');
        return;
      }
      
      console.log('Product added to cart:', lastNonWarrantyItem.title);

      const cartItemKey = [
        lastNonWarrantyItem.id,
        lastNonWarrantyItem.key,
        lastNonWarrantyItem.quantity,
      ].filter(Boolean).join(':');

      if (
        cartItemKey &&
        cartItemKey === lastProcessedCartItemKey &&
        Date.now() - lastProcessedAt < CART_EVENT_COOLDOWN
      ) {
        console.log('Duplicate cart event detected, skipping');
        return;
      }
      
      // Only process on product pages where offers are loaded
      if (!window.offers || window.offers.length === 0) {
        console.log('No warranty offers available');
        return;
      }
      
      const hasWarrantySelected = !!window.selectedWarranty;

      if (hasWarrantySelected && isAddingWarrantyInternally) {
        console.log('Warranty already selected and being added, skipping modal flow');
        return;
      }
      
      // ==========================
      // INLINE FLOW (Warranty already selected)
      // ==========================
      if (hasWarrantySelected && !isProcessingWarranty) {
        console.log('Product added with warranty selected, adding warranty');
        
        isProcessingWarranty = true;
        isAddingWarrantyInternally = true; // Block future events
        
        try {
          const offer = window.selectedWarranty.offer || window.selectedWarranty;
          
          if (!offer) {
            console.error('Invalid warranty object:', window.selectedWarranty);
            return;
          }
          
          const result = await window.mulberryShop.getWarrantyVariant(offer);

          await wait(300);
          
          const resp = await window.mulberryShop.addWarrantyToCart(
            result.shopify_variant_id,
            {
              ...window.productForWarranty,
              variantId: `${window.selectedVariant.id}`,
              quantity: lastNonWarrantyItem.quantity || 1,
            },
            offer
          );
          const cart = await mulberryShop.cart.fetchCart()
          
          window.dispatchEvent(new CustomEvent('mulberry:buildCart',{ detail: cart }));
          lastProcessedCartItemKey = cartItemKey;
          lastProcessedAt = Date.now();
        } catch (err) {
          console.error('Warranty add failed:', err);
        } finally {
          isProcessingWarranty = false;
          isAddingWarrantyInternally = false; // Allow events again
          
          window.selectedWarranty = null;
          
          if (window.mulberry?.inline?.deselectOffer) {
            window.mulberry.inline.deselectOffer();
          }
        }
      }
      // ==========================
      // MODAL FLOW (Product added, show warranty modal)
      // ==========================
      else if (!hasWarrantySelected && !isModalOpen && !isProcessingWarranty) {
        console.log('Product added, opening warranty modal');
        
        lastProcessedCartItemKey = cartItemKey;
        lastProcessedAt = Date.now();
        isModalOpen = true;
        
        setTimeout(() => {
          try {
            closeCartDrawerIfOpen().then(() => {
              if (isAddingWarrantyInternally || window.selectedWarranty) {
                console.log('Skipping modal open because warranty is selected or being added');
                isModalOpen = false;
                return;
              }

              if (window.mulberry?.modal?.open) {
                window.mulberry.modal.open();
              } else {
                console.error('Modal not available');
                isModalOpen = false;
              }
            }).catch((err) => {
              console.error('Drawer close error:', err);
              isModalOpen = false;
            });
          } catch (err) {
            console.error('Modal error:', err);
            isModalOpen = false;
          }
        }, MODAL_OPEN_DELAY);
      } else {
        console.log('Modal already open or warranty processing, skipping');
      }
    } catch (err) {
      console.error('Error handling product added event:', err);
    }
  }, CART_EVENT_DELAY); // Let cart update and avoid burst requests
}

// ==========================
// INIT FLOW
// ==========================
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("mulberry-shopify:loaded", async function () {
    window.mb_gtm_is_disabled = true;

    // DEBUG: Uncomment to find exact event name from sticky cart
    // window.addEventListener = new Proxy(window.addEventListener, {
    //   apply(target, thisArg, args) {
    //     const [eventName, handler] = args;
    //     if (eventName.includes('qikify') || eventName.includes('cart') || eventName.includes('product')) {
    //       console.log(`[STICKY CART EVENT] ${eventName}`, handler);
    //     }
    //     return Reflect.apply(target, thisArg, args);
    //   }
    // });
    // document.addEventListener = new Proxy(document.addEventListener, {
    //   apply(target, thisArg, args) {
    //     const [eventName, handler] = args;
    //     if (eventName.includes('qikify') || eventName.includes('cart') || eventName.includes('product') || eventName.includes('added')) {
    //       console.log(`[DOCUMENT EVENT LISTENER] ${eventName}`, handler);
    //     }
    //     return Reflect.apply(target, thisArg, args);
    //   }
    // });

    await removeAndSyncWarranties();

    if (location.href.includes("/products/") && !hideMulberry.includes(location.pathname)) {
      initMulberry();
    }
    
    // Listen for product added to cart event
    if (!isCartEventBound) {
      window.addEventListener('itemAdded', handleProductAddedToCart);
      isCartEventBound = true;
    }
    // // Also listen for boosterkit updates which contain product data
    // document.addEventListener('boosterkit-data-updated', handleProductAddedToCart);

    let lastUrl = location.href;
    let currentVariant;

    function getUrlParam(name) {
      const match = new RegExp('[?&]' + name + '=([^&]*)')
        .exec(location.search);
      return match ? decodeURIComponent(match[1]) : '';
    }

    async function handleUrlChange() {
      const variant = getUrlParam('variant');

      if (variant && variant !== currentVariant && window.pdpInline) {
        currentVariant = variant;

        window.selectedWarranty = null;
        window.pdpInline.deselectOffer();

        mulberryShop.selectedVariantId = variant;

        const selectedVariant = getCurrentlySelectedVariant(theProduct);

        const mainVariant = getMainVariant(theProduct);
        window.offers = await mulberry.core.getWarrantyOffer({
          id: selectedVariant.id,
          title: theProduct.title,
          price: mainVariant.price,
          detail: theProduct,
        });

        if (window.offers?.length) {
          document.querySelector('#mulberry-container').style.display = 'block';
          document.querySelector('#whats-covered-faq').style.display = 'flex';
          window.pdpInline.updateOffer(window.offers);
          window.mulberry.modal.updateOffer(window.offers);
        } else {
          document.querySelector('#mulberry-container').style.display = 'none';
          document.querySelector('#whats-covered-faq').style.display = 'none';
        }
      }
    }

    new MutationObserver(() => {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        handleUrlChange();
      }
    }).observe(document.body, { childList: true, subtree: true });

    handleUrlChange();
  });
});

// ==========================
// GET OFFERS
// ==========================
async function getOffers() {
  const productData = await window.mulberryShop.getProductData(
    window.mulberryShop.getProductUrl()
  );

  const product = productData.product;
  theProduct = product;

  window.selectedVariant = product.variants.find(
    (i) => i.id == window.mulberryShop.selectedVariantId
  ) || product.variants[0];

  window.mainVariant = product.variants[0];

  if (window.selectedVariant?.price) {
    return window.mulberry.core.getWarrantyOffer({
      detail: { ...product, id: window.selectedVariant.id },
      title: product.title,
      id: window.selectedVariant.id,
      price: window.mainVariant.price,
    });
  }
}

// ==========================
// INIT MULBERRY
// ==========================
async function initMulberry() {
  window.offers = await getOffers();

  console.log('Mulberry initialized:', window.offers);

  window.pdpInline = await window.mulberry.inline.init({
    offers: window.offers,
    settings: window.mulberry.core.settings,
    selector: "#mulberry-container",
    layout: {
        ctaText: true,
        faq: false,
        input: 'buttons',
        logo: true,
        stacked: true,
      },
    onWarrantyToggle: (warranty) => {
      if (warranty.isSelected) {
        window.selectedWarranty = warranty;
        window.productForWarranty = theProduct;
      } else {
        window.selectedWarranty = null;
        window.productForWarranty = null;
      }
    },
  });
  if(offers.length > 0){
    mulberry.faq.init({
      coverage: mulberry.core.offers[0],
      settings: mulberry.core.settings
    })
    document.querySelector("#whats-covered-faq").removeAttribute("style")
    document.querySelector("#whats-covered-faq")?.addEventListener("click",function(){
      mulberry.faq.open();
    });
  }
  window.mulberry.modal.init({
    offers: window.offers,
    settings: window.mulberry.core.settings,

    onWarrantySelect: async (warranty) => {
      console.log('Warranty selected from modal:', warranty);

      isAddingWarrantyInternally = true; // Block event handling while adding warranty
      
      try {
        await closeCartDrawerIfOpen();

        const offer = warranty.offer || warranty;

        if (!offer) {
          console.error('Invalid warranty object:', warranty);
          return;
        }

        const result = await window.mulberryShop.getWarrantyVariant(offer);

        await wait(300);

        try {
            const resp = await window.mulberryShop.addWarrantyToCart(
                result.shopify_variant_id,
                {
                    ...theProduct,
                    variantId: `${window.selectedVariant.id}`,
                    quantity: 1,
                },
                offer
            );
            const cart = await mulberryShop.cart.fetchCart()
            window.dispatchEvent(new CustomEvent('mulberry:buildCart',{ detail: cart }));
        } catch (err) {
          console.error('Add warranty error:', err);
        }

        console.log('Warranty added (modal)');
      } catch (err) {
        console.error('Warranty add failed:', err);
      } finally {
        // Close modal and reset state
        window.mulberry.modal.close();
        isModalOpen = false;
        
        // Re-enable event handling after a short delay
        setTimeout(() => {
          isAddingWarrantyInternally = false;
        }, 500);
      }
    },

    onWarrantyDecline: () => {
      console.log('Warranty declined');

      window.mulberry.modal.close();
      isModalOpen = false;
      // Don't need to reset flag here since user declined
    },
  });
}

// ==========================
// CART CLEANUP
// ==========================
async function removeAndSyncWarranties() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    cart.items = cart.items.filter(
      item => item?.properties?._variantId !== 'sectional'
    );


    const newCart = await mulberryShop.removeDetachedWarranty(cart);
    const data = await mulberryShop.cart.syncQuantities(newCart);
    console.log(cart);
    console.log(data);
    if (location.pathname === '/cart' && cart.total_price != data.total_price) {
      location.reload();
    }

  } catch (err) {
    console.error('Cart sync error:', err);
  }
}

// ==========================
// CART PAGE REFRESH
// ==========================
document.addEventListener(
  'mulberry-shopify:warranty-added',
  () => {
    if (location.pathname === '/cart') {
      location.reload();
    }
  }
);
